import React from 'react';
import { AlertDialog, HStack, Box, Button as NBButton, View, useBreakpointValue, } from 'native-base';
import { Platform } from 'react-native';
import { Text } from '../atoms';
const isIos = Platform.OS === 'ios';
let modalCtasOrientation = 'horizontal';
export function Modal({ isOpen, children, ctas = [] }) {
    const cancelRef = React.useRef(null);
    const paddingX = useBreakpointValue({
        base: 16,
        sm: 40,
    });
    function renderButtons() {
        return (React.createElement(ButtonContainer, null, ctas.map(({ text, onPress, type = 'primary' }) => (React.createElement(React.Fragment, { key: text },
            type === 'primary' && (React.createElement(Button, { onPress: onPress, variant: "primary", testID: "modal-button-primary" }, text)),
            type === 'secondary' && (React.createElement(Button, { onPress: onPress, variant: "secondary", testID: "modal-button-secondary" }, text)))))));
    }
    return (React.createElement(AlertDialog, { leastDestructiveRef: cancelRef, isOpen: isOpen, 
        // @ts-expect-error invalid token
        backgroundColor: "colors.neutral.overlay", style: isIos
            ? {
                zIndex: 12,
                shadowColor: '#000000',
                shadowOffset: { width: 0, height: 0 },
                shadowOpacity: 0.4,
                shadowRadius: 8,
                paddingHorizontal: paddingX,
            }
            : { paddingHorizontal: paddingX, elevation: 12 } },
        React.createElement(AlertDialog.Content, { backgroundColor: "neutral.container", style: isIos
                ? undefined
                : {
                    elevation: 12,
                    // shadowColor: '#FF0000',
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 0 },
                    shadowOpacity: 0.4,
                    shadowRadius: 8,
                } },
            React.createElement(Box, { px: 5, pt: 5 }, children),
            ctas.length > 0 ? renderButtons() : null)));
}
function Header({ children, IconLeft, IconRight, testID }) {
    return (React.createElement(HStack, { alignItems: "center", mb: 2 },
        IconLeft,
        React.createElement(Box, { flex: 1, mr: "auto", ml: IconLeft ? 2 : 0 },
            React.createElement(Text, { testID: testID, fontToken: "bodyLargeMedium", color: "text.100", textAlign: "left" }, children)),
        IconRight));
}
function BodyText({ children, ...rest }) {
    return (React.createElement(Text, { fontToken: "bodyBaseDefault", color: "text.100", ...rest }, children));
}
function Body({ children }) {
    return React.createElement(Box, null, children);
}
function ButtonContainer({ children, ctasOrientation = 'horizontal' }) {
    modalCtasOrientation = ctasOrientation;
    return (React.createElement(Box, { flexDirection: modalCtasOrientation === 'horizontal' ? 'row' : 'column', alignContent: "center", justifyContent: "center", borderTopWidth: 1, borderTopColor: "neutral.30", mt: 5, mx: -5 }, children));
}
function Button({ onPress, children, variant = 'primary', testID }) {
    const fontToken = variant === 'primary' ? 'bodyBaseMedium' : 'bodyBaseDefault';
    return (React.createElement(NBButton, { flex: modalCtasOrientation === 'horizontal' ? 1 : 0, mx: 2, py: modalCtasOrientation === 'horizontal' ? 3 : 3, onPress: onPress, backgroundColor: "neutral.container", testID: testID },
        React.createElement(Text, { fontToken: fontToken, color: "interactive.text.active" }, children)));
}
function ButtonDivider() {
    return modalCtasOrientation === 'horizontal' ? (React.createElement(View, { flex: 0, borderRightWidth: 1, borderRightColor: "neutral.30" })) : (React.createElement(View, { flex: 0, borderTopWidth: 1, borderTopColor: "neutral.30" }));
}
Modal.Header = Header;
Modal.Body = Body;
Modal.BodyText = BodyText;
Modal.ButtonContainer = ButtonContainer;
Modal.Button = Button;
Modal.ButtonDivider = ButtonDivider;
